import { createSelector } from '@ngrx/store';
import { AppState, SnackBarMessage } from '@ra-state';

export const snackbarFeature = (state: AppState): any => state.snackBarData;
export const selectDisplayMessage = createSelector(snackbarFeature, (state: SnackBarMessage) => state.data);
